import {
    getRegistration,
    listRegistrations
} from './queries';
import {
    createRegistration,
    deleteRegistration,
    updateRegistration,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Registration} from "../types.ts";
import {generateClient} from "aws-amplify/api";
import {stripReadonlyFields} from '../../../utils/stripReadonlyFields';
import {
    notifyError,
    notifySuccess
} from "../../../components/ServiceNotifications.tsx";

import {ListRecordsQuery} from "../../../types";

export type ListRegistrations = {
    listRegistrations: { items: Registration[], nextToken: string }
}

export type GetRegistration = {
    getRegistration: Registration
}

export type CreateRegistration = {
    createRegistration: Registration
}

export type UpdateRegistration = {
    updateRegistration: Registration
}

export type DeleteRegistration = {
    deleteRegistration: string
}


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListRegistrations>>({
            query: listRegistrations,
            variables: {...query},
        });
        return {
            items: response.data?.listRegistrations.items,
            nextToken: response.data?.listRegistrations.nextToken,
        };
    } catch (e) {
        notifyError(e);
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetRegistration>>({
            query: getRegistration,
            variables: {id: id},
        });
        return response.data?.getRegistration;
    } catch (e) {
        notifyError(e);
    }
};

export const add = async (payload: object) => {
    try {
        const response = await client.graphql<GraphQLQuery<CreateRegistration>>({
            query: createRegistration,
            variables: {input: payload},
        });
        notifySuccess('Registration added successfully');
        return response.data?.createRegistration;
    } catch (e) {
        notifyError(e);
    }
};

export const update = async (_id: string, record: Registration) => {
    const payload = stripReadonlyFields(record);
    try {
        const response = await client.graphql<GraphQLQuery<UpdateRegistration>>({
            query: (updateRegistration),
            variables: {input: payload},
        });
        notifySuccess('Registration updated successfully');
        return response.data?.updateRegistration;
    } catch (e) {
        notifyError(e);
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteRegistration>>({
            query: (deleteRegistration),
            variables: {input: {id: id}},
        });
        notifySuccess('Registration deleted successfully');
        return response.data?.deleteRegistration;
    } catch (e) {
        notifyError(e);
    }
};
